import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import parallaxStyle from "assets/jss/material-kit-react/components/parallaxStyle.jsx"

// core components
import waitlistCta from "data/waitlist-hero.json";

// Sections for this page
import CTASection from "components/CTASection/CTASection.jsx";

import OutstretchedHand from "components/Background/OutstretchedHand.jsx";

const filter = parallaxStyle.filter;

const waitlistStyle = {

};

class WaitlistCTA extends React.Component {
  render() {
    const { classes, listIds, ...rest } = this.props;
    return (
      <OutstretchedHand>
        <CTASection cta={waitlistCta} listIds={[29].concat(listIds)} filterOpacity="0.3"/>
      </OutstretchedHand>
    );
  }
}

export default withStyles(waitlistStyle)(WaitlistCTA);
